export default {
  computed: {
    selectedHost: {
      get() {
        return this.$store.state.selectedHost;
      },
      set(value) {
        this.$store.commit("changeHost", value);
      },
    },
    loading: {
      get() {
        return this.$store.state.loading;
      },
      set(value) {
        this.$store.commit("setLoading", value);
      },
    },
  },
};
